module.exports = __webpack_public_path__ + "img/s7.4991f09d.png";